import { useLocation, useParams } from 'react-router-dom';
import { ReportsCommissionPage } from 'src/components/ReportsCommissionPage';
import { Content } from 'src/contexts/ContentContext';
import { DialogProvider } from 'src/contexts/DialogContext/DialogContext';
import { WarningMessage } from 'src/core/POS/MessageWithIcon';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import {
  useReportConfigsV2,
  useReportPermissions,
} from 'src/hooks/reportConfigs';
import { LayoutContent } from 'src/navigations/LayoutContent';
import { ContentId } from 'src/utils/constants/contentId';
import { ReportTypesV2 } from 'src/utils/reportsUtils';

import { MainRoute } from '../MainRoute';
import { ReportsCommissionContextProviderV2 } from './ReportsCommissionContextProviderV2';

export function ReportsCommission() {
  const { hasAccessToReportingV2, hasReportSinglePagedV1V2Feature } =
    useReportPermissions();

  const location = useLocation();

  const isFromV1Page = location.state?.isFromV1Page === true;

  const mainRoute =
    !hasAccessToReportingV2 || isFromV1Page || hasReportSinglePagedV1V2Feature
      ? MainRoute.Reports
      : MainRoute.ReportsV2;

  return (
    <LayoutContent mainRoute={mainRoute}>
      <ReportsCommissionContentV2 />
    </LayoutContent>
  );
}

function ReportsCommissionContentV2() {
  const { reportId } = useParams();
  const location = useLocation();

  const { reportConfigs, isLoading, isFetching } = useReportConfigsV2({
    reportTypes: [ReportTypesV2.Commission],
  });

  const reportConfig = reportConfigs?.find(
    (r) => r.reportId?.toString() === reportId
  );

  if (reportConfig == null) {
    return isLoading || isFetching ? (
      <PosSpinner />
    ) : (
      <Stack
        width="full"
        direction="column"
        alignItems="center"
        style={{ padding: vars.spacing.xxl }}
      >
        <WarningMessage
          message={<Content id={ContentId.ReportNotAvailable} />}
        />
      </Stack>
    );
  }

  return (
    <ReportsCommissionContextProviderV2 reportConfig={reportConfig}>
      <DialogProvider>
        <ReportsCommissionPage />
      </DialogProvider>
    </ReportsCommissionContextProviderV2>
  );
}
